import { render, staticRenderFns } from "./RequisicaoPDF.vue?vue&type=template&id=79efbc99&scoped=true"
import script from "./RequisicaoPDF.vue?vue&type=script&lang=js"
export * from "./RequisicaoPDF.vue?vue&type=script&lang=js"
import style0 from "./RequisicaoPDF.vue?vue&type=style&index=0&id=79efbc99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79efbc99",
  null
  
)

export default component.exports